import { Datetime } from 'vue-datetime';
import LineChart from '../charts/LineChart.js';
import DoughnutChart from '../charts/DoughnutChart.js';
import moment from 'moment';

if($('#network-reporting').length){
    var app = new Vue({
        el: '#network-reporting',
        data: {
            networkId: networkId,
            endDate: moment().format('YYYY-MM-DDTHH:mm:ssz'),
            startDate: null,
            existingStartDate: existingStartDate,
            data:{},
            dateCounts:{},
            applicationResponse:{},
            expertResponse:{},
            loaded:false,
            responses:{
                labels:[
                    'Pending',
                    'Not Interested',
                    'Unsure',
                    'Interested'
                ],
                colors:[
                    '#ccc',
                    '#e20d0d',
                    '#f8a01c',
                    '#2dcc70'
                ]
            },
            doughnutOptions:{
                responsive: true, 
                maintainAspectRatio: false, 
                cutoutPercentage: 85,
                legend: {
                    display: false
                },
            },
            lineOptions:{
                responsive: true, 
                maintainAspectRatio: false, 
                scaleFontColor: "#4F4F4F",
                legend: {
                    display: true,
                    labels: {
                        usePointStyle:true,
                        padding:30,
                        fontColor: '#111',
                        fontSize: 13,
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            userCallback: function(label, index, labels) {
                                // when the floored value is the same as the value we have a whole number
                                if (Math.floor(label) === label) {
                                    return label;
                                }
                            },
                            fontColor: '#111',
                            fontSize: 13
                        }
                    }],
                    xAxes: [{
                        ticks:{
                            autoSkip: true,
                            maxTicksLimit: 20,
                            fontColor: '#111',
                            fontSize: 13,
                            padding: 5
                        }
                    }]
                }  
            },
            performance: 0,
            expertPerformance: 0,
            performanceLabel: 'Calculating...',
            performanceColour: 0,
            performanceTarget: 0,
            performanceValue: 0,
            performanceDays: 0,
            currentLengthRan: 0
        },
        methods: {
            get: function() {
                if(this.startDate && this.endDate){
                    axios.get('/api/v1/network/'+this.networkId+'/reporting?startDate='+this.startDate+'&endDate='+this.endDate).then((response) =>  {
                        this.data = response.data;
    
                        if(this.data.applicationResponses.length){
                            this.applicationResponse = this.generateResponseChartData(this.data.applicationResponses);
                        }
    
                        this.dateCounts = this.generateLineChartData(this.data);
    
                        this.loaded = true;
                    }).catch((error) => {
                        this.errorHandler(error);
                    });
                }
            },
            getPerformance: function() {
                axios.get('/api/v1/network/'+this.networkId+'/performance').then((response) =>  {
                    response = response.data;

                    this.currentLengthRan = response.currentLengthRan;
                    this.performanceValue = response.currentApplicationsCount;
                    this.performanceTarget = Math.round((response.averageApplications / response.averageDateDiff)*response.currentLengthRan);
                    var performance = (100/this.performanceTarget)*response.currentApplicationsCount;

                    this.performance = performance > 100 ? 100 : performance;
                    this.performanceDays = Math.round(response.currentLengthRan);

                    if(performance < 33.33){
                        this.performanceLabel = 'Poor';
                        this.performanceColour = '#e20d0d';
                    }else if(performance >= 33.33 && performance < 66.66){
                        this.performanceLabel = 'Average';
                        this.performanceColour = '#f8a01c';
                    }else if(performance >= 66.66 && performance < 100){
                        this.performanceLabel = 'Good';
                        this.performanceColour = '#FFDB58';
                    }else{
                        this.performanceLabel = 'Excellent';
                        this.performanceColour = '#2dcc70';
                    }
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            getResponseTotal(id, data){
                if(data){
                    let response = data.filter(obj => {
                        return obj.application_response_id === id
                    });
                    if(response[0]){
                        return response[0].total;
                    }else{
                        return 0;
                    }
                }
            },
            generateResponseChartData(object){
                var data = [];
                var colors = [];
                var labels = [];
                var responses = this.responses;

                object.forEach(function(response, index){
                    if(response.application_response_id != null){
                        labels.push(responses.labels[response.application_response_id]);
                        colors.push(responses.colors[response.application_response_id]);
                    }else{
                        labels.push('Pending');
                        colors.push('#999');
                    }
                    data.push(response.total);
                });

                return {
                    labels:labels,
                    datasets: [
                        {
                            backgroundColor: colors,
                            data: data
                        }
                    ]
                }
            },
            generatePerformanceChartData(object){
                this.needleValue = 50;
            },
            generateLineChartData(object){
                var labels = [];
                var dateKeys = Object.keys(object.innovationApplicationsByDay);

                dateKeys.forEach(function(date){
                    labels.push(moment(date).format('MMM Do'));
                });

                var data = {
                    labels:labels,
                    datasets: [
                        {
                            label: ' Innovation Applications',
                            borderColor: '#FF6965',
                            fill: false,
                            lineTension:0,
                            pointRadius:4,
                            pointBackgroundColor:'#FF6965',
                            pointBorderColor:'#FF6965',
                            borderWidth:2,
                            data: Object.values(object.innovationApplicationsByDay)
                        }, {
                            label: ' Expert Applications',
                            borderColor: '#4930DC',
                            fill: false,
                            lineTension:0,
                            pointRadius:4,
                            pointBackgroundColor:'#4930DC',
                            pointBorderColor:'#4930DC',
                            borderWidth:2,
                            data: Object.values(object.expertApplicationsByDay)
                        }, {
                            label: ' Views',
                            borderColor: '#61BF78',
                            fill: false,
                            lineTension:0,
                            pointRadius:4,
                            pointBackgroundColor:'#61BF78',
                            pointBorderColor:'#61BF78',
                            borderWidth:2,
                            data: Object.values(object.viewsByDay)
                        }
                    ]
                }
                return data;
            },
            getStartDate(){
                if(existingStartDate && existingStartDate < moment().subtract(30, 'days').format('YYYY-MM-DDTHH:mm:ssz')){
                    return moment(existingStartDate).format('YYYY-MM-DDTHH:mm:ssz');
                }else{
                    return moment().subtract(30, 'days').format('YYYY-MM-DDTHH:mm:ssz');
                }
            },
            errorHandler(error){
                if(error.response && typeof error.response.data === 'string'){
                    this.$toasted.error(error.response.data);
                }else if(error.response){
                    this.$toasted.error(error.response.data.message);
                }else{
                    console.log(error);
                }
            }
        },
        components: {
            'Datetime': Datetime,
            'line-chart': LineChart,
            'doughnut-chart': DoughnutChart
        },
        mounted () {
            this.startDate = this.getStartDate();
            this.get();
            this.getPerformance();
        }
    });
}